<script lang="ts">
	import monikaSromova from "../assets/images/monika-sromova.png?webp&w=580&h=580&imagetools";
	import janaKvetonova from "../assets/images/jana-kvetonova.png?webp&w=580&h=580&imagetools";
	import alenaHahnova from "../assets/images/alena-hahnova.jpg?webp&w=580&h=580&imagetools";
	import { getTranslate } from "../utils/getTranslate.js";
	import translations from "./ContactCards.translations.json";
	import ContactCard from "./ContactCard.svelte";
	import type { ContactCardPerson } from "./ContactCardPerson.js";
	import { flyInOnScroll } from "../utils/flyInOnScroll";
	import { nbspify } from "../../../core/utils/nbspify.js";

	// TODO: Replace with real data
	const partners: ContactCardPerson[] = [
		{
			name: "Monika Šromová",
			description: "monika.sromova@brano.eu",
			image: monikaSromova,
		},
		{
			name: "Jana Květoňová",
			description: "jana.kvetonova@brano.eu",
			image: janaKvetonova,
		},
		{
			name: "Alena Hahnová",
			description: "alena.hahnova@brano.eu",
			image: alenaHahnova,
		},
	];

	const translate = getTranslate(translations);
	const dontShowContactPeopleFf = true;
	/* eslint-disable @typescript-eslint/explicit-function-return-type, svelte/no-at-html-tags */
</script>

{#if !dontShowContactPeopleFf}
	<div class="container">
		<h2 class="mx-auto mb-[6.25rem] text-xl font-semibold md:text-2xl lg:text-4xl">
			{translate("heading")}
		</h2>
		<div class="flex flex-wrap justify-center gap-6 lg:grid lg:min-h-[36.25rem] lg:grid-cols-2 xl:grid-cols-3">
			{#each partners as person, index}
				<ContactCard {index} {person} />
			{/each}
		</div>
	</div>
{:else}
	<div class="container lg:pb-24">
		<h2 class="text-lg leading-[1.13] sm:text-xl lg:text-4xl" use:flyInOnScroll>
			{@html translate("findingSolution")}
		</h2>
		<a
			use:flyInOnScroll
			class="my-12 block text-lg font-bold no-underline sm:text-2xl lg:my-24 lg:text-[6rem]"
			href="mailto:sales@brano.eu"
		>
			{nbspify("sales@brano.eu")}
		</a>
	</div>
{/if}
